import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage, useUploadImages } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { Button, Stack, IconButton } from '@mui/material'
import Multiselect from './components/Multiselect'
import Editor from 'components/editor'
import CloseIcon from '@mui/icons-material/Close'

const CreateModal = ({ handleRefresh, apps, category }) => {
  const uploadImage = useUploadImage()
  const uploadImage2 = useUploadImages()

  const [agency] = useAgencyInfo()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [description, setDescription] = useState('')
  const [images, setImages] = useState([])

  const [selectedAwards, setSelectedAwards] = useState([]);

  // Handle image file selection
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files)
    setImages(prev => [...prev, ...files])
  }

  // Remove image by index
  const handleRemove = (idx) => {
    setImages(prev => prev.filter((_, i) => i !== idx))
  }

  const handleModal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
    setImages([])
    setDescription('')
  }

  const catOptions = category?.map(item => ({
    label: item?.name,
    value: item?._id,
  }))

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    let image_responses = [];
    if (images.length) {
      image_responses = await Promise.all(
        images.map((file) =>
          uploadImage({ file, desiredPath: `app/logo/image` })
        )
      );
    }

    const payload = {
      name: e.target.name.value,
      video: e.target.video_link.value,
      description,
      path: e.target.path.value,
      library: image_responses.map((r) => r?.response?.data),
    };

    console.log(payload, "payload");

    const { response } = await AppService.allTheAppDescription.create({ payload });

    if (response) {
      setProcessing(false);
      closeAddProduct();
      handleRefresh();
    } else {
      setProcessing(false);
    }
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} >
            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>


            <MDBox mb={2}>
              <MDTypography variant="button">Path</MDTypography>
              <MDInput label="path" name="path" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Video Link</MDTypography>
              <MDInput label="Video Link" name="video_link" fullWidth />
            </MDBox>
            <Stack direction="row" alignItems="center" spacing={2} style={{ marginTop: 10 }}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Images +
                <input hidden multiple name="images" type="file" onChange={handleImageChange} />
              </Button>
            </Stack>
            <MDBox>
              {images.map((file, idx) => (
                <MDBox
                  key={idx}
                  sx={{
                    position: 'relative',
                    display: 'inline-block',
                    marginTop: 2,
                    marginRight: 2,
                  }}
                >
                  <img
                    src={URL.createObjectURL(file)}
                    alt="preview"
                    style={{
                      width: 60,
                      height: 60,
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                  <IconButton
                    size="small"
                    sx={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      backgroundColor: 'white',
                      ':hover': { backgroundColor: 'red' },
                    }}
                    onClick={() => handleRemove(idx)}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </MDBox>
              ))}
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
 